/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import clsx from 'clsx';
import { Spin } from 'antd';

import { Typography } from '@atoms';

import s from './styles.module.less';

const ImagePreview = ({ src, className, alt }) => {
  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState(null);

  const handleImageOnLoad = () => {
    setLoading(false);
    setError(null);
  };

  const handleImageOnError = (e) => {
    setLoading(false);
    setError(e);
  };

  if (error) return <Typography.Text>An error occurred while loading image</Typography.Text>;

  return (
    <Spin spinning={loading} wrapperClassName={clsx(s.spinWrapper, className)}>
      <img className={s.image} src={src} alt={alt} onLoad={handleImageOnLoad} onError={handleImageOnError} />
    </Spin>
  );
};

export default ImagePreview;
